import { useDispatch } from 'react-redux';
import {
  getSamsaraGpsCoordinates,
  getSamsaraTrucks,
  setSamsaraFilter,
  clearSamsaraState
} from 'actions/samsaraActions';

export function useSamsaraActions() {
  const dispatch = useDispatch();

  const getSamsaraGpsCoordinatesAction = () => dispatch(getSamsaraGpsCoordinates());
  const getSamsaraTrucksAction = () => dispatch(getSamsaraTrucks());
  const setSamsaraFilterAction = (filter) => dispatch(setSamsaraFilter(filter));
  const clearSamsaraStateAction = () => dispatch(clearSamsaraState());

  return {
    getSamsaraGpsCoordinatesAction,
    getSamsaraTrucksAction,
    setSamsaraFilterAction,
    clearSamsaraStateAction
  };
}
